import { Component } from '@angular/core';

import { SessionProvider } from '../../providers/session/session';
//import { interval } from 'rxjs/observable/interval';
import 'rxjs/add/operator/startWith';
import { Events } from 'ionic-angular';

import { InAppBrowser } from '@ionic-native/in-app-browser';

import { ADS_BANNER_INTERVAL, ADS_BANNER_TIMEOUT, EVT_RESIZE_CONTENT } from '../../constants';


@Component({
  selector: 'ads-banner',
  templateUrl: 'ads-banner.html',
})
export class AdsBannerComponent {

  showBanner: Boolean = true;

  constructor(public session: SessionProvider, public iab: InAppBrowser, public events: Events) {

    //Produce que el banner apareza y desaparezca
/*
    interval(ADS_BANNER_INTERVAL).startWith(0)
      .subscribe(val => {
        this.showBanner = !this.showBanner;
        this.events.publish(EVT_RESIZE_CONTENT);
        setTimeout(() => {
          this.showBanner = !this.showBanner;
          this.events.publish(EVT_RESIZE_CONTENT);
        }, ADS_BANNER_TIMEOUT);
      });
*/
  }

  openAdsInBrowser() {
    const url = this.session.getAdsLink();
    //console.log('url', url);
    const browser = this.iab.create(url, '_system');
  }

}



// WEBPACK FOOTER //
// ./src/components/ads-banner/ads-banner.ts